import { TypeBody1, TypeOverline } from "../../atoms/fonts/Types";
import { IcoBrand } from "../../atoms/icons/IcoBrand";
import { IconLinkedIn, IconMail, IconPhone, IconPin } from "../../atoms/icons/Icons";
import { useT } from "../../../i18n/LanguageContext";
import "./FooterContent.css";

const PHONE = "+1 (814) 441-6131";
const EMAIL = "management@nearshoredesign.co";
const LINKEDIN_URL = "https://www.linkedin.com/company/near-shore-design-co/";

export function FooterContent() {
	const { t } = useT();
	const year = new Date().getFullYear();
	const capabilities = t("services.items");

	const navLinks = [
		{ href: "#services", key: "services" },
		{ href: "#sellaris", key: "work" },
		{ href: "#process", key: "process" },
		{ href: "#about", key: "about" },
		{ href: "#contact", key: "contact" },
	];

	return (
		<div className="footerContent">
			<div className="footerContent_top">
				<div className="footerContent_brand">
					<IcoBrand className="footerContent_logo" />
					<TypeOverline className="footerContent_tagline">{t("footer.tagline")}</TypeOverline>
					<a
						href={LINKEDIN_URL}
						className="footerContent_social"
						target="_blank"
						rel="noreferrer noopener"
						aria-label="LinkedIn"
					>
						<IconLinkedIn />
					</a>
				</div>

				<nav className="footerContent_nav" aria-label="Footer">
					<div className="footerContent_navCol">
						<span className="footerContent_navTitle">{t("footer.sections.company")}</span>
						<ul>
							{navLinks.map((l) => (
								<li key={l.key}>
									<a href={l.href}>{t(`nav.${l.key}`)}</a>
								</li>
							))}
						</ul>
					</div>

					<div className="footerContent_navCol">
						<span className="footerContent_navTitle">{t("footer.sections.services")}</span>
						<ul>
							{Array.isArray(capabilities) &&
								capabilities.map((c) => (
									<li key={c.key}>
										<a href="#services">{c.title}</a>
									</li>
								))}
						</ul>
					</div>

					<div className="footerContent_navCol">
						<span className="footerContent_navTitle">{t("footer.sections.contact")}</span>
						<ul className="footerContent_contactList">
							<li>
								<a href={`tel:${PHONE.replace(/[^\d+]/g, "")}`}>
									<IconPhone />
									<span>{PHONE}</span>
								</a>
							</li>
							<li>
								<a href={`mailto:${EMAIL}`}>
									<IconMail />
									<span>{EMAIL}</span>
								</a>
							</li>
							<li>
								<span className="footerContent_static">
									<IconPin />
									<span>{t("contact.info.location")}</span>
								</span>
							</li>
						</ul>
					</div>
				</nav>
			</div>

			<span className="footerContent_wordmark" aria-hidden="true">
				Near Shore Design
			</span>

			<div className="footerContent_bottom">
				<TypeBody1 className="footerContent_copy">
					© {year} Near Shore Design — {t("footer.rights")}
				</TypeBody1>
			</div>
		</div>
	);
}
